import styled from '../../styled-components';
import { CallbackTitle } from './CallbackTitle';
export const StyledCallbackTitle = styled(CallbackTitle).withConfig({
  displayName: "styledelements__StyledCallbackTitle",
  componentId: "sc-791zlc-0"
})(["padding:10px;border-radius:2px;margin-bottom:4px;line-height:1.5em;background-color:", ";cursor:pointer;"], ({
  theme
}) => theme.colors.gray[100]);
export const CallbackDetailsWrap = styled.div.withConfig({
  displayName: "styledelements__CallbackDetailsWrap",
  componentId: "sc-791zlc-1"
})(["padding:10px 25px;background-color:", ";margin-bottom:5px;margin-top:5px;"], ({
  theme
}) => theme.colors.gray[50]);